import React, { Component } from "react";
import { Link } from 'react-router-dom';

export default class PageTables extends Component {
	  	
	render () {
		
		let block = this.props.block;
										
	    return (
		    
		    <div className="l-grid">
		    
		    	<div className="l-grid__col">
		    	
		    		<div className="c-page__block c-page__block--text-space c-page__block--load-effect">
						
						{block.tables.map((table,i) =>
							{
								return (
								    <div className="c-table" key={i}>
										<h3 className="c-table__heading" dangerouslySetInnerHTML={{__html:table.heading}}></h3>
										<div className="c-table__el">
											
											{table.row.map((row,j) =>
												{
													if (row.url) {
														if (row.url.indexOf('http') === -1) {
															return (
																<Link to={{ pathname:row.url}} className="c-table__row" key={j}>
																	<div className="c-table__td c-table__td--1">
																		<h3 className="c-table__text" dangerouslySetInnerHTML={{__html:row.first_column}}></h3>
																	</div>
																	<div className="c-table__td c-table__td--2">
																		<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.second_column}}></p>
																	</div>
																	<div className="c-table__td c-table__td--3">
																		<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.third_column}}></p>
																	</div>
																</Link>
															)
														} else {
															return (
																<a href={row.url} target="_blank" className="c-table__row" key={j}>
																	<div className="c-table__td c-table__td--1">
																		<h3 className="c-table__text" dangerouslySetInnerHTML={{__html:row.first_column}}></h3>
																	</div>
																	<div className="c-table__td c-table__td--2">
																		<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.second_column}}></p>
																	</div>
																	<div className="c-table__td c-table__td--3">
																		<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.third_column}}></p>
																	</div>
																</a>
															)
														}
													} else {
														return (
															<div className="c-table__row" key={j}>
																<div className="c-table__td c-table__td--1">
																	<h3 className="c-table__text" dangerouslySetInnerHTML={{__html:row.first_column}}></h3>
																</div>
																<div className="c-table__td c-table__td--2">
																	<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.second_column}}></p>
																</div>
																<div className="c-table__td c-table__td--3">
																	<p className="c-table__text" dangerouslySetInnerHTML={{__html:row.third_column}}></p>
																</div>
															</div>
														)
													}
												}
											)}
										</div>
									</div>
									
								)	
							}
						)}
				    
				    </div>
				    
				</div>
		    
		    </div>
		)
	}
}
